import React from 'react'
import mac from "./img/kallwealth.png"
import web from "./img/kallwealth.png"
import Image from "../../../../Components/Image"


function Kallwealth() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Kallwealth</div>
                <div className="work_type">Web Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        Kallwealth is a a reputable and competent indigenous facility engineering company with global competitiveness and strength.
                    </p>
                    <p>
                    Kallwealth aims to improve on and maintain a high standard of engineering practice, in environmental, construction, procurement, facility and project management services.
                    </p>
                    <p>
                        kallwealth offers the following services:
                        <ul>
                            <li>Engineering and construction</li>
                            <li>Agriculture</li>
                            <li>Environmental</li>
                            <li>Equipment leasing & sales</li>
                            <li>Marketing</li>
                            <li>Consultancy</li>
                        </ul>
                    </p>
                    <a href='https://kallwealth.com.ng' className="work_btn" target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> Boostrap, Animate, JQuery etc.</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={mac} />
            </div>
        </div>
    )
}

export default Kallwealth